import { ref, onUnmounted } from 'vue'

const DEFAULT_THREAD_WIDTH = 408
const MIN_THREAD_WIDTH = 300

export function useResizeHandle({ onResize, onResizeEnd, maxWidth } = {}) {
	const isDragging = ref(false)
	let startX = 0
	let startWidth = 0
	let rafId = null

	function onPointerDown(e, currentWidth) {
		e.preventDefault()
		isDragging.value = true
		startX = e.clientX
		startWidth = currentWidth

		document.addEventListener('pointermove', onPointerMove)
		document.addEventListener('pointerup', onPointerUp)
		document.body.style.userSelect = 'none'
		document.body.style.cursor = 'col-resize'
	}

	function onPointerMove(e) {
		if (!isDragging.value) return
		const clientX = e.clientX
		if (rafId) return
		rafId = requestAnimationFrame(() => {
			rafId = null
			const delta = startX - clientX
			const max = typeof maxWidth === 'function' ? maxWidth() : Infinity
			const newWidth = Math.min(
				max,
				Math.max(MIN_THREAD_WIDTH, startWidth + delta)
			)
			onResize?.(newWidth)
		})
	}

	function onPointerUp() {
		if (rafId) {
			cancelAnimationFrame(rafId)
			rafId = null
		}
		isDragging.value = false
		document.removeEventListener('pointermove', onPointerMove)
		document.removeEventListener('pointerup', onPointerUp)
		document.body.style.userSelect = ''
		document.body.style.cursor = ''
		onResizeEnd?.()
	}

	function resetToDefault() {
		onResize?.(DEFAULT_THREAD_WIDTH)
		onResizeEnd?.()
	}

	onUnmounted(() => {
		if (rafId) {
			cancelAnimationFrame(rafId)
			rafId = null
		}
		document.removeEventListener('pointermove', onPointerMove)
		document.removeEventListener('pointerup', onPointerUp)
		document.body.style.userSelect = ''
		document.body.style.cursor = ''
	})

	return {
		isDragging,
		onPointerDown,
		resetToDefault,
		DEFAULT_THREAD_WIDTH,
		MIN_THREAD_WIDTH,
	}
}
